import * as types from '../types';
import moment from 'moment';
import update from 'immutability-helper';
import {
    VIEW_MODE,
    EDIT_MODE,
} from '@Utils/constants';
import { formatAmount } from '@Utils/formatters';

export const initialAddForm = {
    id: 0,
    applicantID: 0,
    generatedApplicantID: '',
    interviewID: 0,
    positionLevelID: 0,
    positionLevelName: '',
    positionID: 0,
    positionAccepted: '',
    discussionDate: '',
    f2FDetails: '',
    recommendedSalary: formatAmount(0),
    jobRate: formatAmount(0),
    jobOfferStatus: 11,
    applicantAcceptance: '',
    auditTrails: [],
    additionalInformation:
    {
        employeeID: '',
        yearsOfIndustry: '',
        department: 0,
        section: 0,
        gender: 1,
        birthDate: moment().format('MM/DD/YYYY'),
        atkStamp: 1,
        accessLevel: '',
        approver1: 0,
        approver2: 0,
        approver3: 0,
        batchId: 0,
        employeeClass: 0,
    },
};

const defaultState = {
    loading: false,
    addForm: { ...initialAddForm },
    emailTemplate: { subject: '', body: '' },
    mode: EDIT_MODE,
    isEditable: true,
    hasLoadedData: false,
    alert: {
        show: false,
        title: 'Create success',
        content: 'Successfully create record',
        confirmLabel: 'Ok',
        goBackToListFlag: false,
        onHide: () => { },
    },
    info: {
        infoShow: false,
        infoTitle: 'Additional Employee Information',
        infoLabel: 'Submit'
    },
    confirm: {
        confirmShow: false,
    },
    syncConfirm: {
        syncConfirmShow: false,
    }
};

export default function addReducer(state = defaultState, action) {
    switch (action.type) {
        case types.CHG_FIELD:
        case types.CHG_STATUS:
            return update(state, {
                addForm: {
                    [action.payload.name]: { $set: action.payload.data }
                }
            });
        case types.RESET_ADD_DATA:
            return update(state, {
                addForm: { $set: initialAddForm },
                alert: { $set: defaultState.alert },
                mode: { $set: defaultState.mode },
                isEditable: { $set: defaultState.isEditable }
            });
        case types.INSERT_LOADING:
            return update(state, {
                loading: { $set: action.payload }
            });
        case types.UPD_ADD_ALERT:
            return update(state, {
                alert: { $set: action.payload }
            });
        case types.UPD_ADD_MODE:
            return update(state, {
                mode: { $set: action.payload }
            });
        case types.HIDE_SHOW_MODAL:
            return update(state, {
                [action.typeModal]: { [`${action.typeModal}Show`]: { $set: action.payload } },
            });
        case types.HIDE_ADD_ALERT:
            return update(state, {
                alert: { show: { $set: false } }
            });
        case types.HAS_ADD_LOADED:
            return update(state, {
                hasLoadedData: { $set: action.payload }
            });
        case types.SET_ADD_DATA:
            let initialMode = action.mode === 'addview' || action.mode === 'view' ? VIEW_MODE : EDIT_MODE;
            let editable = initialMode === EDIT_MODE ? true : false;

            return update(state, {
                addForm: { $set: action.payload },
                alert: { $set: defaultState.alert },
                mode: { $set: initialMode },
                isEditable: { $set: editable }
            });
         case types.SET_ADD_EMAIL_TEMPLATE:
            return update(state, {
                emailTemplate: { $set: action.payload }
            });
        default:
            return state;
    }
};